import React from "react";
import "../Styles/DentalTourism.css";
import dentalTourismData from "../contents/DentalTourism";

const DentalTourism = () => {
  return (
    <section className="dental-tourism">
      {/* Page Title */}
      <h1>{dentalTourismData.title}</h1>

      {/* Render HTML content */}
      <div
        className="dental-tourism-content"
        dangerouslySetInnerHTML={{
          __html: dentalTourismData.fullContent,
        }}
      />
    </section>
  );
};

export default DentalTourism;
